import { paginatedTransform } from 'src/services/skuit/utils'
import { Case, PaginatedResponse } from '../../api/models'

import { API, CustomAxiosConfig } from './types'

export class Cases {
  api: API

  constructor(api: API) {
    this.api = api
  }

  list = async (config: CustomAxiosConfig = {}): Promise<PaginatedResponse<Case>> => {
    const response = await this.api.get('/logistics/cases', config)
    return paginatedTransform(Case)(response.data)
  }
}
